import styled from 'styled-components';

const ExpiryCvcWrapper = styled.div`
  @media (min-width: 400px) {
    display: flex;
    gap: 1.3rem;
  }
`;

const InnerExpiryCvcWrapper = styled.div`
  margin-top: 1.2rem;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  margin-top: 2.2rem;
`;

const RecaptchaWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export {
  ExpiryCvcWrapper,
  InnerExpiryCvcWrapper,
  ButtonWrapper,
  RecaptchaWrapper
};
